var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMenuStyles, MenuButton } from "@chakra-ui/react";
import SvgSpriteConsumer from "../SvgSprite/SvgSpriteConsumer";
import { Button, ButtonVariant } from "../Button";
const DropdownMenuButton = (_a) => {
    var { isOpen, title, children, variant = ButtonVariant.SECONDARY_FILLED } = _a, rest = __rest(_a, ["isOpen", "title", "children", "variant"]);
    const styles = useMenuStyles();
    return (_jsx(Button, Object.assign({}, rest, { sx: styles.button, variant: variant, rightIcon: _jsx(SvgSpriteConsumer, { svgId: isOpen ? "chevronUp24" : "chevronDown24", size: 24 }), as: MenuButton }, { children: title })));
};
DropdownMenuButton.displayName = "DropdownMenuButton";
export default DropdownMenuButton;
//# sourceMappingURL=DropdownMenuDsButton.js.map